import React from 'react';
import ChartDataLabels from 'chartjs-plugin-datalabels';

import { Bar, HorizontalBar } from 'react-chartjs-2';
import {
  bool, func, number, shape, string,
} from 'prop-types';
import { textWrap } from '../../../utils/text-format-helper';
import { Container } from './styles';

const BarChart = (props) => {
  const {
    data,
    height,
    width,
    onBarClicked,
    stacked,
    tooltips,
    type,
    maxHeightValue,
    paddingTop,
    xAxesFontSize,
    yAxesLabel,
    xAxesFormater,
  } = props;

  const handleElementsClick = (elements) => {
    const element = elements[0];

    if (data.ids && data.ids.length > 0 && element) {
      const { _index: elementIndex } = element;
      element.id = data.ids[elementIndex];
    }

    if (onBarClicked && element) {
      onBarClicked(element);
    }
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    tooltips,
    legend: {
      display: false,
    },
    scales: {
      xAxes: [{
        maxBarThickness: 20,
        stacked,
        gridLines: {
          drawBorder: true,
          drawTicks: false,
          drawOnChartArea: false,
        },
        ticks: {
          beginAtZero: true,
          fontSize: xAxesFontSize,
          min: 0,
          precision: 1,
          stepSize: props.stepSize,
          ...(xAxesFormater && { callback: xAxesFormater }),
          ...(maxHeightValue && { max: maxHeightValue }),
          padding: 5,
          callback: (label) => textWrap(label, 15),
        },
      }],
      yAxes: [{
        maxBarThickness: 20,
        stacked,
        scaleLabel: {
          display: !!yAxesLabel,
          labelString: yAxesLabel,
        },
        gridLines: {
          drawBorder: true,
          drawTicks: false,
          drawOnChartArea: false,
        },
        ticks: {
          beginAtZero: true,
          min: 0,
          precision: 1,
          stepSize: props.stepSize,
          ...(maxHeightValue && { max: maxHeightValue }),
          padding: 10,
        },
      }],
    },
    layout: {
      padding: {
        left: 0,
        right: 0,
        top: paddingTop,
        bottom: 0,
      },
    },
    onHover: (event, chartElement) => {
      // eslint-disable-next-line no-param-reassign
      event.target.style.cursor = (chartElement[0] && onBarClicked) ? 'pointer' : 'default';
    },
    plugins: {
      datalabels: {
        display: false,
      },
    },
  };

  if (type === 'horizontal') {
    return (
      <Container>
        <HorizontalBar
          height={height}
          width={width}
          data={data}
          options={options}
          onElementsClick={handleElementsClick}
        />
      </Container>
    );
  }

  return (
    <Container>
      <Bar
        plugins={[ChartDataLabels]}
        data={data}
        width={width}
        height={height}
        options={options}
        onElementsClick={handleElementsClick}
      />
    </Container>
  );
};

BarChart.propTypes = {
  data: shape({}).isRequired,
  height: number,
  width: number,
  onBarClicked: func,
  stacked: bool,
  stepSize: number,
  tooltips: shape({
    callbacks: shape({
      title: func,
      label: func,
    }),
  }),
  type: string.isRequired,
  xAxesFontSize: number,
  xAxesFormater: func,
  yAxesLabel: string,
  maxHeightValue: number,
  paddingTop: number,
};

BarChart.defaultProps = {
  height: undefined,
  width: undefined,
  onBarClicked: undefined,
  maxHeightValue: undefined,
  stacked: false,
  stepSize: 1,
  paddingTop: 20,
  tooltips: {
    callbacks: {
      title: (tooltipItem) => textWrap(tooltipItem[0].label, 150),
      label: () => '',
    },
  },
  xAxesFontSize: 12,
  yAxesLabel: null,
  xAxesFormater: null,
};

export default BarChart;
